<template>
  <div class="home-product">
    <div class="container">
    <div class="home-product-title">{{ $t("home.productlist") }}</div>
      <div class="home-product-line"></div>

      <div class="home-product-list">
        <div class="home-product-border" @click="toPWmatIntroduce">
          <div>
            <img class="home-product-img" src="../../assets/home/pwmat.jpg">
            <div class="home-product-name">PWmat</div>
          </div>
        </div>

        <div class="home-product-border" @click="toMLFFIntroduce">
          <img class="home-product-img" src="../../assets/home/matpl.jpg">
          <div class="home-product-name">MatPL</div>
        </div>

        <div class="home-product-border" @click="toPWstudioIntroduce">
          <img class="home-product-img" src="../../assets/home/PWstudio.jpg">
          <div class="home-product-name">PWstudio</div>
        </div>

        <div class="home-product-border" @click="toIntelliMatIntroduce">
          <img class="home-product-img" src="../../assets/home/home_intellimat.jpg">
          <div class="home-product-name">IntelliMat</div>
        </div>

        <div class="home-product-border" @click="toQStudioAIIntroduce">
          <img class="home-product-img" src="../../assets/home/Q-Studio.jpg">
          <div class="home-product-name">Q-Studio AI</div>
        </div>

        <div class="home-product-border" @click="toNanoReactorIntroduce">
          <img class="home-product-img" src="../../assets/home/NanoReactor.jpg">
          <div class="home-product-name">NanoReactor</div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'HelloWorld',
  props: {

  },
  components: {

  },
  methods:{
    toPWmatIntroduce(){
      this.$router.push({ name: 'PWmatIntroduce'})
    },
    toMSTATIONIntroduce(){
      this.$router.push({ name: 'MSTATIONIntroduce'})
    },
    toDMSTATIONIntroduce(){
      this.$router.push({ name: 'DMSTATIONIntroduce'})
    },
    toMCLUSTERIntroduce(){
      this.$router.push({ name: 'MCLUSTERIntroduce'})
    },
    toMcloudIntroduce(){
      this.$router.push({ name: 'McloudIntroduce'})
    },
    toMLFFIntroduce(){
      this.$router.push({ name: 'MLFFIntroduce'})
    },
    toIntelliMatIntroduce(){
      this.$router.push({ name: 'IntelliMatIntroduce'})
    },
    toPWstudioIntroduce(){
      this.$router.push({ name: 'PWstudioIntroduce'})
    },
    toIntegration(){
      this.$router.push({ name: 'Integration'})
    },
    toQStudioAIIntroduce(){
      this.$router.push({ name: 'QStudioAIIntroduce'})
    },
    toPWMGUIIntroduce(){
      this.$router.push({ name: 'PWMGUIIntroduce'})
    },
    toNanoReactorIntroduce(){
      this.$router.push({ name: 'NanoReactorIntroduce'})
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home-product-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .home-product{
    margin-top: 60px;
  }
  .home-product-title{
    font-size:32px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(73,145,201,1);
    line-height:45px;
  }
  .home-product-line{
    height:1px;
    margin-top: 8px;
    background:rgba(240,240,240,1);
  }
  .home-product-list{
    margin: 10px -15px 0 -15px;
  }
  .home-product-border{
    width: 180px;
    margin: 30px 5px 0px 5px;
    display: inline-block;
    cursor: pointer;
    padding-bottom: 25px;
    border: 1px solid rgba(240,240,240,1);
    vertical-align: top;
  }
  .home-product-border:hover{
    border: 1px solid rgba(73,145,201,1);
  }
  .home-product-img{
    width: 180px;
    height: 148px;
    object-fit: cover;
    display: block;
  }
  .home-product-name{
    margin-top: 20px;
    font-size:18px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(73,145,201,1);
    line-height:33px;
    text-align: center;
  }
  .home-product-desc{
    margin: 28px 16px 0 16px;
    font-size:14px;
    font-family:PingFangSC-Light,sans-serif;
    font-weight:300;
    color:rgba(79,76,77,1);
    line-height:29px;
  }
  @media (max-width: 576px) {
    .home-product-list{
      text-align: center;
    }
  }

  @media (min-width: 576px) and (max-width:768px) {
    .home-product-list{
      text-align: center;
    }
  }

  @media (min-width: 768px) and (max-width:992px) {
    .home-product-list {
      text-align: center;
    }
  }

  @media (min-width: 1200px) and (max-width:992px){
    .home-product-border {
      width: 182px;
      margin: 30px 5px 0 5px;
    }
    .home-product-img{
      width: 180px;
      height: 124px;
    }
  }

  @media (min-width: 1200px) {

  }
</style>
